import { ToastContainer as ReactToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ToastContainer.css";

export const ToastContainer = () => {
  return (
    <ReactToastContainer
      position="top-right"
      autoClose={4000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      style={{
        fontSize: "0.95rem",
        fontFamily: "var(--_fonts---texts, Poppins, sans-serif)",
      }}
      toastStyle={{
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
      }}
    />
  );
};

export default ToastContainer;
